import ResponsiveAppBar from "./ResponsiveNavBar";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import { useTheme } from "@mui/material/styles";

export default function SiteLayout() {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: theme.palette.primary.dark,
                height: "100%",
                p: 0,
                m: 0,
                minHeight: "100vh",
            }}
        >
            <ResponsiveAppBar />
            <Box
                sx={{
                    flex: 1,
                    minWidth: "100vw",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Outlet />
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center">
                <Footer />
            </Box>
        </Box>
    );
}
